// extracted by mini-css-extract-plugin
var _1 = "accordion-summary__sQHYb";
var _2 = "error__JP8Eg";
var _3 = "error--not_possible__pV3B4";
var _4 = "error--not_suitable_for_mothers__HI40R";
var _5 = "error--possible_with_measures__WgUNm";
var _6 = "examinations-list-container__tIO4a";
var _7 = "followup-summary__cenp8";
var _8 = "signs-list__U9wXx";
var _9 = "signs-list-entry__Onm4O";
export { _1 as "accordion-summary", _2 as "error", _3 as "error--not_possible", _4 as "error--not_suitable_for_mothers", _5 as "error--possible_with_measures", _6 as "examinations-list-container", _7 as "followup-summary", _8 as "signs-list", _9 as "signs-list-entry" }
